import { render, staticRenderFns } from "./banner_contact.vue?vue&type=template&id=adeb7006&"
import script from "./banner_contact.vue?vue&type=script&lang=js&"
export * from "./banner_contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports